import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_DELIVERY_METRIC } from '../interfaces/ISalesDelivery';

class AnalyticDeliveryService extends EntityApiService<any> {
  searchByMetric = (metric: ANALYTIC_DELIVERY_METRIC, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));
  };
}

export default new AnalyticDeliveryService('/ms-analytics/api/v1/overdue-orders');
